import _extends from "@babel/runtime/helpers/extends";
import { Button, Typography } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import React from 'react';
const UploadArea = _ref => {
  let classes = _ref.classes,
    title = _ref.title,
    mark = _ref.mark,
    help = _ref.help,
    status = _ref.status,
    buttonLabel = _ref.buttonLabel,
    inputLabel = _ref.inputLabel,
    inputRef = _ref.inputRef,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.uploadArea
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.uploadAreaHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.uploadAreaTitle
  }, title), mark && /*#__PURE__*/React.createElement("span", {
    className: mark === 'Required' ? classes.uploadMarkRequired : classes.uploadMarkOptional
  }, mark)), help && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.uploadAreaHelp
  }, help), status && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    role: "status",
    className: classes.uploadAreaStatus
  }, status), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      type: "file-text"
    }),
    onClick: () => {
      var _inputRef$current;
      return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
    },
    disabled: disabled
  }, buttonLabel), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "file",
    accept: ".csv",
    hidden: true,
    "aria-label": inputLabel,
    onChange: onChange
  })));
};

/**
 * The two files a single-reading template takes, side by side where there is room and stacked on a phone. Each has its
 * own input and sends the same parse request; which one it is decides only what the screen does with the answer.
 */
export const ReadsUploadAreas = _ref2 => {
  let classes = _ref2.classes,
    start = _ref2.start,
    end = _ref2.end;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.uploadAreas
  }, /*#__PURE__*/React.createElement(UploadArea, _extends({
    classes: classes
  }, start)), /*#__PURE__*/React.createElement(UploadArea, _extends({
    classes: classes
  }, end)));
};